/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 条件
 * @export
 * @enum {string}
 */

export const FilterCondition = {
    Inc: 'inc',
    Exc: 'exc'
} as const;

export type FilterCondition = typeof FilterCondition[keyof typeof FilterCondition];



